exports.HOTEL_AFFILIATE_ID = '211001';
